import * as React from 'react';
import { cn } from '@/lib/utils';

export interface TabItem {
  value: string;
  label: string;
  content: React.ReactNode;
}

interface TabsComponentProps {
  tabs: TabItem[];
  defaultValue?: string;
}

export function TabsComponent({ tabs, defaultValue }: TabsComponentProps) {
  const [activeTab, setActiveTab] = React.useState(
    defaultValue || tabs[0].value,
  );

  return (
    <div className="w-full">
      <div className="border-b border-[#e0e0e0]">
        <div className="flex justify-center sm:justify-start gap-4">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              onClick={() => setActiveTab(tab.value)}
              className={cn(
                'pb-4 px-2 sm:px-0 sm:mr-8 text-[#6b6866] hover:text-black transition-colors relative whitespace-nowrap text-xs sm:text-sm md:text-base',
                activeTab === tab.value && 'text-black font-medium',
              )}
            >
              {tab.label}
              {activeTab === tab.value && (
                <div
                  className="absolute bottom-0 inset-x-0 mx-2 sm:mx-0 h-0.5 bg-black"
                  style={{ width: 'calc(100% - 16px)' }}
                />
              )}
            </button>
          ))}
        </div>
      </div>
      <div className="mt-6">
        {tabs.map((tab) => (
          <div
            key={tab.value}
            className={cn(activeTab !== tab.value && 'hidden')}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
}
